import {Routes, Route, Navigate} from 'react-router-dom'

import {PageLink, PageTitle} from '../../../../../_metronic/layout/core/PageData'
import {useIntl} from 'react-intl'
import {ServerList} from './ServerList'
import {ServerForm} from './ServerForm'
import { useAuth } from '../../../auth'

const ServerRoutes = () => {
  const intl = useIntl();
  const ROLE_MANAGER = parseInt(process.env.REACT_APP_ROLE_MANAGER+"");
  const ROLE_EMPLOYEE = parseInt(process.env.REACT_APP_ROLE_EMPLOYEE+"");
  
  const {checkAuthorization} = useAuth();
  const breadcrumbs: Array<PageLink> = [
    {
      title: 'Arteco Insight',
      path: '',
      isSeparator: false,
      isActive: false,
      disableLink: true,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
    {
      title: intl.formatMessage({id: 'MENU.SYSTEM_SETTINGS'}),
      path: '',
      isSeparator: false,
      isActive: false,
      disableLink: true,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]

  const breadcrumbs_with_lista: Array<PageLink> = [
    {
      title: 'Arteco Insight',
      path: '',
      isSeparator: false,
      isActive: false,
      disableLink: true,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
    {
      title: intl.formatMessage({id: 'MENU.SYSTEM_SETTINGS'}),
      path: '',
      isSeparator: false,
      isActive: false,
      disableLink: true,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
    {
      title: intl.formatMessage({id: 'MENU.SYSTEM_SETTINGS.SERVERS'}),
      path: '/system-settings/servers',
      isSeparator: false,
      isActive: false,
      disableLink: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]
  return (
    <Routes>
      <Route
        index
        element={
          <>
            <PageTitle breadcrumbs={breadcrumbs}>
              {intl.formatMessage({id: 'MENU.SYSTEM_SETTINGS.SERVERS'})}
            </PageTitle>
            <ServerList />
          </>
        }
      />
      {checkAuthorization([ROLE_MANAGER]) &&<Route
        path='add'
        element={
          <>
            <PageTitle breadcrumbs={breadcrumbs_with_lista}>
              {intl.formatMessage({id: 'SYSTEM_SETTINGS.SERVERS.ADD'})}
            </PageTitle>
            <ServerForm />
          </>
        }
      />}
      {checkAuthorization([ROLE_MANAGER]) && <Route
        path='edit/:id'
        element={
          <>
            <PageTitle breadcrumbs={breadcrumbs_with_lista}>
              {intl.formatMessage({id: 'SYSTEM_SETTINGS.SERVERS.EDIT'})}
            </PageTitle>
            <ServerForm />
          </>
            }
        
      />
        }
        <Route path='*' element={<Navigate to='/error/404' />} />
    </Routes>
  )
}

export {ServerRoutes}
